import { Box } from '@/components/box';
import { ProjectPhaseWithToolkitItems } from '@/components/project/types';
import { Text } from '@/components/text';
import { AnimatedArrow } from './animated-arrow';

interface ProjectPhasesDiagramProps {
  projectPhases: ProjectPhaseWithToolkitItems[];
}

export function ProjectPhasesDiagram({
  projectPhases,
}: ProjectPhasesDiagramProps) {
  return (
    <Box
      css={{
        display: 'flex',
        flexFlow: 'column nowrap',
        gap: '$8',
        mt: '$8',
        mb: '12rem',
        '@bp5': {
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          gridColumn: '3 / 18',
        },
      }}
    >
      {projectPhases.map((projectPhase, projectPhaseIndex) => (
        <Box
          as="button"
          key={projectPhase._id}
          className="phase-item"
          css={{
            display: 'flex',
            flexFlow: 'row nowrap',
            cursor: 'pointer',
            '@bp5': {
              flexGrow: 1,
              justifyContent: 'stretch',
            },
          }}
          onClick={() =>
            document
              .getElementById(projectPhase._id)
              ?.scrollIntoView({ behavior: 'smooth' })
          }
        >
          <Box
            css={{
              flexGrow: projectPhaseIndex,
              '@bp5': { display: 'none' },
            }}
          />
          <Box
            css={{
              display: 'flex',
              flexFlow: 'row nowrap',
              position: 'relative',
              pb: '$2',
              '@bp5': {
                flexGrow: 1,
              },
            }}
          >
            <Box
              css={{
                position: 'relative',
                display: 'flex',
                flexFlow: 'row nowrap',
                alignItems: 'center',
                gap: '$4',
                paddingRight: '4rem',
                maxWidth: '15rem',
              }}
            >
              <Text
                size={13}
                css={{
                  margin: 0,
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {projectPhase.order}
              </Text>
              <Box>
                <Text size={4}>{projectPhase.title}</Text>
              </Box>
            </Box>
            <AnimatedArrow isActive={true} side="left" />
            <AnimatedArrow isActive={true} side="right" />
            <AnimatedArrow isActive={false} side="left" />
            <AnimatedArrow isActive={false} side="right" />
          </Box>
          <Box
            css={{
              flexGrow: projectPhases.length - projectPhaseIndex - 1,
              '@bp5': { display: 'none' },
            }}
          />
        </Box>
      ))}
    </Box>
  );
}
